import {Entity} from '@s-ui/domain'

const isUndefined = value => value === undefined
const addProperty = property => !isUndefined(property) && property

/**
 * @implements Entity
 * Motor Subscription Ad (Vehicle) Entity
 * The param "hasNoCommitmentOption" means that the Ad has a "No commitment" option, regardless of other commitment options that could be available or not
 */
export default class SubscriptionAdEntity extends Entity {
  /**
   * @constructor
   * @param {Array} commitmentMonthlyOptions
   * @param {String} description
   * @param {String} deps.fuelTypeId
   * @param {Boolean} hasNoCommitmentOption
   * @param {Number} id
   * @param {String} imgUrl
   * @param {String} make
   * @param {String} model
   * @param {Number} minimumMonthlyFee
   * @param {String} partnerName
   * @param {Number} powerHp
   * @param {String} segment
   * @param {String} title
   * @param {String} transmissionTypeId
   * @param {String} url
   * @param {String} version
   * @param {Number} deps.year
   */

  getSegment() {
    return this._segment
  }

  /**
   * @return {Object}
   */
  toJSON() {
    return {
      ...addProperty({
        commitmentMonthlyOptions: this._commitmentMonthlyOptions
      }),
      ...addProperty({description: this._description}),
      ...addProperty({specificFuelTypeId: this._specificFuelTypeId}),
      ...addProperty({hasNoCommitmentOption: this._hasNoCommitmentOption}),
      ...addProperty({id: this._id}),
      ...addProperty({imgUrl: this._imgUrl}),
      ...addProperty({make: this._make}),
      ...addProperty({model: this._model}),
      ...addProperty({minimumMonthlyFee: this._minimumMonthlyFee}),
      ...addProperty({partnerName: this._partnerName}),
      ...addProperty({powerHp: this._powerHp}),
      ...addProperty({segment: this._segment}),
      ...addProperty({title: this._title}),
      ...addProperty({transmissionTypeId: this._transmissionTypeId}),
      ...addProperty({url: this._url}),
      ...addProperty({version: this._version}),
      ...addProperty({year: this._year})
    }
  }
}
